<template lang="pug">
  .component-create-entity-button
    ModalReveal(:ref="`maintenance-${_uid}`", @input="close")
      button.button.success.expanded(slot="trigger", @click="open") Add sub request
      h2 Add sub request to IR{{body.linked_intervention_request_id}}
      InterventionRequestForm(v-model="body", :subRequest="true")
      ActionButton(slot="footer", :action="save") Save
      button.button.alert.float-right(slot="footer", @click="close(false)") Cancel
</template>

<script>
import DatePicker from '../../components/structure/DatePicker'
import ModalReveal from '../../components/structure/foundation/ModalReveal'
import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
import ActionButton from '../../components/structure/ui/ActionButton'
import SelectizeVehicle from "../../components/structure/ui/lists/selectize/SelectizeVehicle.vue";
import InterventionRequestForm from "../../components/structure/forms/InterventionRequestForm.vue";
import {EventBus} from "../../eventBus";

export default {
  name: 'CreateSubInterventionRequestReveal',
  components: {InterventionRequestForm, SelectizeVehicle, ActionButton, ModalReveal, DatePicker},
  data() {
    return {
      body: {},
    }
  },
  methods: {
    save() {
      return KeplerBackofficeSdk.maintenanceRequest.make(this.body, () => {
        EventBus.$emit('reload-list')
        EventBus.$emit('close-modal')
      })
    },
    open() {
      this.body = {
        status: null,
        linked_intervention_request_id: this.request.linked_intervention_request_id,
        vehicle_id: this.request.vehicle_id,
        maintenance_driver_id: null,
        priority: null,
        type: [],
        description: null,
        expiry: null,
        has_linked_requests: false,
        disable_vehicle_slot: false
      }
    },
    close(val) {
      EventBus.$emit('close-modal')
    }
  },
  computed: {},
  props: {
    request: null
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreateSubInterventionRequestReveal.vue?220b77dc